import { useTranslation } from 'react-i18next';
import GhostButton from '../GhostButton';
import PrimaryButton from '../PrimaryButton';
import { pluralForm } from '../../helpers/pluralForm';

const Svg = ({ children, width = '1.8' }) => (
  <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

// Mock icons: ↺ for the repick, ↻ for the recount.
const RepickIcon = () => (
  <Svg>
    <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
    <path d="M3 3v5h5" />
  </Svg>
);
const RecalcIcon = () => (
  <Svg width="1.9">
    <path d="M21 12a9 9 0 1 1-3-6.7L21 8" />
    <path d="M21 3v5h-5" />
  </Svg>
);

/** Live selection counter and the two table actions, the top of the table card (mock .toolbar). `count`/`result` come from the table. */
function TableToolbar({ count, result, onRepick, onRecalculate }) {
  const { t, i18n } = useTranslation();
  const k = (key, opts) => t(`taxPlanner.scr02.table.${key}`, opts);
  return (
    <div data-testid="table-toolbar" className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2.5 border-b border-border px-4 py-3.5">
      <span data-testid="selected-counter" className="num text-[13px] text-text">
        {count > 0 ? k(`counter_${pluralForm(count, i18n.language)}`, { count, result }) : k('counterNone')}
      </span>
      <div className="flex flex-wrap items-start gap-x-4 gap-y-3">
        <div className="flex max-w-[240px] flex-col gap-1.5">
          <GhostButton size="lg" className="gap-2" aria-describedby="table-toolbar-repick-hint" onClick={onRepick}>
            <RepickIcon />
            {k('repick')}
          </GhostButton>
          <span id="table-toolbar-repick-hint" className="text-[11px] leading-[1.35] text-text-muted">{k('repickHint')}</span>
        </div>
        <div className="flex max-w-[240px] flex-col gap-1.5">
          <PrimaryButton size="lg" aria-describedby="table-toolbar-recalc-hint" onClick={onRecalculate}>
            <RecalcIcon />
            {k('recalculate')}
          </PrimaryButton>
          <span id="table-toolbar-recalc-hint" className="text-[11px] leading-[1.35] text-text-muted">{k('recalculateHint')}</span>
        </div>
      </div>
    </div>
  );
}

export default TableToolbar;
